// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"13655d3c","977":"07c9437d"}[chunkId] + ".chunk.js";
};